import React from "react";

/**
 * WaveDecor — courbe de Bézier fine et fluide, utilisée en transition de section
 * ou en accent décoratif traçant l'idée du "mouvement" propre à la danse.
 *
 * Props :
 * - variant : "primary" (turquoise) | "soft" (bleu clair) | "muted"
 * - stroke : épaisseur du trait (défaut 1.5)
 * - animate : booléen pour activer l'animation d'ondulation (stroke-dashoffset)
 */
export function WaveDecor({
  variant = "primary",
  stroke = 1.5,
  animate = true,
  className = "",
  style = {},
}) {
  const colorByVariant = {
    primary: "#00C6CE",
    soft: "#66EAF0",
    muted: "#CBD5E1",
  };
  const color = colorByVariant[variant] || colorByVariant.primary;
  return (
    <svg
      aria-hidden="true"
      className={`pointer-events-none ${className}`}
      style={{ overflow: "visible", ...style }}
      viewBox="0 0 800 100"
      preserveAspectRatio="none"
    >
      <path
        d="M0,50 C 150,10 300,90 450,50 C 600,10 750,90 800,50"
        fill="none"
        stroke={color}
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeDasharray={animate ? "6 8" : "none"}
        className={animate ? "animate-ondulate" : ""}
      />
    </svg>
  );
}
